import { useParams } from 'react-router-dom';
import { PracticeDetail } from '../components/practice-detail.js';
import { PracticesPage } from '../components/practices-page.js';

/** The athlete's own Practices page and practices, from Home (boards R1, R2). */
export function AthletePracticesRoute() {
  const { practiceId } = useParams();
  if (practiceId) {
    return <PracticeDetail practiceId={practiceId} whose="" back={{ to: '/practices', label: 'Back to Practices' }} editable />;
  }
  return (
    <PracticesPage
      athleteClientId={null}
      title="Practices"
      back={{ to: '/', label: 'Back to Home' }}
      start="/tools/recul"
      practiceLink={(id) => `/practices/${id}`}
    />
  );
}
